var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoPurchasingTool(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "24px",
    viewBox: "0 0 28 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 40") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-817.000000, -1210.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(817.000000, 1211.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.00026329,8.5 L4.90026329,21.5 L22.412202,21.5 L26.312202,8.5 L1.00026329,8.5 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.65623264,8.60864258 L10.0077951,0",
    id: "Path-108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1562326,8.60864258 L24.5077951,0",
    id: "Path-108-Copy",
    transform: "translate(20.832014, 4.304321) scale(-1, 1) translate(-20.832014, -4.304321) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    transform: "translate(7.909162, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,0 L0.5,6.01098633",
    id: "Path-109"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.24707031,0 L6.24707031,6.01098633",
    id: "Path-109-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2470703,0 L11.2470703,6.01098633",
    id: "Path-109-Copy-2"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPurchasingTool);
export default __webpack_public_path__ + "static/media/ico_purchasing-tool.9dc162ab41e1a6c0da82e684c58fe69a.svg";
export { ForwardRef as ReactComponent };